
/*
const datasetLabels = {
  exac: 'ExAC v1.0',
  gnomad_r2_1: 'gnomAD v2.1.1',
  gnomad_r2_1_controls: 'gnomAD v2.1.1 (controls)',
  gnomad_r2_1_non_cancer: 'gnomAD v2.1.1 (non-cancer)',
  gnomad_r2_1_non_neuro: 'gnomAD v2.1.1 (non-neuro)',
  gnomad_r2_1_non_topmed: 'gnomAD v2.1.1 (non-TOPMed)',
  gnomad_sv_r2: 'gnomAD SVs',
}
*/

const datasetLabels = {
  sfari_all: "PKD combined",
  sfari_spark: "PKD exomes",
  sfari_sv: 'PKD SVs',
}


export default datasetLabels
